import React from 'react';
import i18n from 'i18next';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DayjsUtils from '@date-io/dayjs';
import zhTwLocale from 'dayjs/locale/zh-tw';
import zhCNLocale from 'dayjs/locale/zh-cn';
import zhHKLocale from 'dayjs/locale/zh-hk';
import enLocale from 'dayjs/locale/en';
import jaLocale from 'dayjs/locale/ja';
import ptLocale from 'dayjs/locale/pt-br';
import esLocale from 'dayjs/locale/es-us';
import thLocale from 'dayjs/locale/th';
import { langTypes } from 'config/gameLangOptions';

const localeMap = {
    [langTypes.ZH_TW]: zhTwLocale,
    [langTypes.ZH_CN]: zhCNLocale,
    [langTypes.ZH_HK]: zhHKLocale,
    [langTypes.EN_US]: enLocale,
    [langTypes.JA_JP]: jaLocale,
    [langTypes.PT_BR]: ptLocale,
    [langTypes.ES_419]: esLocale,
    [langTypes.TH_TH]: thLocale
};

export default function ProviderMuiPickersUtils({ children, lang }) {
    const locale = localeMap[lang] || localeMap[i18n.language];
    return (
        <MuiPickersUtilsProvider utils={DayjsUtils} locale={locale}>
            {children}
        </MuiPickersUtilsProvider>
    );
}
